// @flow
import { PRODUCT_INFORMATION_SUMMARY } from 'Client/cms/toolkit/constants';
import { ProductInformationSummaryLine } from 'Components/lines/product-information-summary-line/ProductInformationSummaryLine.jsx';
import { productInformationSummaryResolver } from './productInformationSummary.resolver';

export const productInformationSummaryDescriptor = {
  name: PRODUCT_INFORMATION_SUMMARY,
  component: ProductInformationSummaryLine,
  resolve: productInformationSummaryResolver.resolve,
};
